/**
 * Cookie-bearing transport for cross-origin Ato surfaces.
 *
 * Connection configuration lives in this folder. The app proxy and Discover
 * need "send the session cookie" or "send no credential at all" decisions, but
 * they must not spell those decisions themselves: a second answer is how the
 * client family diverged before S2/S3. Callers hand their RequestInit here.
 */

export function withCookieAuth(init: RequestInit = {}): RequestInit {
  return { ...init, credentials: "include" };
}

export function withoutCredentials(init: RequestInit = {}): RequestInit {
  return { ...init, credentials: "omit" };
}

export function fetchWithCookieAuth(
  input: RequestInfo | URL,
  init: RequestInit = {},
): Promise<Response> {
  return fetch(input, withCookieAuth(init));
}
